import { JobUsage } from '../../fes';

const tokenFormatter = new Intl.NumberFormat('en-US');

export function formatTokenCount(value: number | undefined): string {
  return typeof value === 'number' ? tokenFormatter.format(value) : '-';
}

export function getTotalTokens(usage: JobUsage | undefined): number | undefined {
  if (!usage || (typeof usage.inputTokens !== 'number' && typeof usage.outputTokens !== 'number')) {
    return undefined;
  }

  return (usage.inputTokens ?? 0) + (usage.outputTokens ?? 0);
}

export function formatTotalTokens(usage: JobUsage | undefined): string {
  return formatTokenCount(getTotalTokens(usage));
}

export function formatUsageSummary(usage: JobUsage | undefined): string | undefined {
  if (!usage) {
    return undefined;
  }

  return [
    `Input: ${formatTokenCount(usage.inputTokens)}`,
    `Output: ${formatTokenCount(usage.outputTokens)}`,
    `Cached input: ${formatTokenCount(usage.cachedInputTokens)}`,
    `Reasoning output: ${formatTokenCount(usage.reasoningOutputTokens)}`,
  ].join(', ');
}
